/* Resham Bazaar Premium Header JavaScript */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Announcement Bar Close Handler
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    const isDismissed = sessionStorage.getItem('rb-announcement-dismissed') === 'true';
    if (isDismissed) {
      announcementBar.style.display = 'none';
      updateHeaderHeights();
    } else {
      const closeBtn = announcementBar.querySelector('.rb-announcement-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          announcementBar.style.display = 'none';
          sessionStorage.setItem('rb-announcement-dismissed', 'true');
          updateHeaderHeights();
        });
      }
    }
  }

  // 2. Helper to recalculate body CSS height properties
  function updateHeaderHeights() {
    setTimeout(() => {
      const header = document.querySelector('#header-component');
      if (header) {
        const height = header.offsetHeight;
        document.body.style.setProperty('--header-height', `${height}px`);
        document.body.style.setProperty('--header-group-height', `${height}px`);
      }
    }, 100);
  }

  // Listen to custom sticky states to recalculate heights if necessary
  const headerComponent = document.querySelector('#header-component');
  if (headerComponent) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-sticky-state') {
          updateHeaderHeights();
        }
      });
    });
    observer.observe(headerComponent, { attributes: true });
  }

  // ==========================================
  // 3. Global Wishlist Synchronizer
  // ==========================================
  
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('rb_wishlist') || '[]');
    } catch (e) {
      console.error('Failed to parse wishlist from LocalStorage:', e);
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem('rb_wishlist', JSON.stringify(wishlist));
    updateWishlistUI();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist } }));
  }

  function toggleWishlist(handle) {
    let wishlist = getWishlist();
    const index = wishlist.indexOf(handle);
    if (index > -1) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(handle);
    }
    saveWishlist(wishlist);
  }

  function updateWishlistUI() {
    const wishlist = getWishlist();

    // Update Wishlist Header Badges
    const badges = document.querySelectorAll('.rb-wishlist-action__badge');
    badges.forEach(badge => {
      if (wishlist.length > 0) {
        badge.textContent = wishlist.length;
        badge.style.display = 'flex';
      } else {
        badge.textContent = '';
        badge.style.display = 'none';
      }
    });

    // Update Heart Toggles on Grid Cards / Product Hero
    const heartButtons = document.querySelectorAll('.rb-product-card__wishlist, .rb-product-page__wishlist');
    heartButtons.forEach(btn => {
      // Don't modify the remove button on the wishlist grid
      if (btn.classList.contains('rb-wishlist-card__remove')) return;

      const handle = btn.getAttribute('data-product-handle');
      if (handle && wishlist.includes(handle)) {
        btn.classList.add('rb-product-card__wishlist--active');
        btn.classList.add('rb-product-page__wishlist--active');
      } else {
        btn.classList.remove('rb-product-card__wishlist--active');
        btn.classList.remove('rb-product-page__wishlist--active');
      }
    });
  }

  // Global event delegation for Wishlist Toggles
  document.body.addEventListener('click', (event) => {
    const button = event.target.closest('.rb-product-card__wishlist, .rb-product-page__wishlist');
    if (button && !button.classList.contains('rb-wishlist-card__remove')) {
      event.preventDefault();
      event.stopPropagation();
      const handle = button.getAttribute('data-product-handle');
      if (handle) {
        toggleWishlist(handle);
      }
    }
  });

  // Initial Sync on Page Load
  updateWishlistUI();

  // Listen for storage changes from other tabs
  window.addEventListener('storage', (event) => {
    if (event.key === 'rb_wishlist') {
      updateWishlistUI();
      document.dispatchEvent(new CustomEvent('wishlist:updated', { 
        detail: { wishlist: JSON.parse(event.newValue || '[]') } 
      }));
    }
  });

  // Expose function globally to let other scripts update the UI
  window.rbUpdateWishlistUI = updateWishlistUI;

  // ==========================================
  // 4. Catalog Direct Add-to-Cart Handler
  // (Adds item to cart & updates cart count badge without opening drawer)
  // ==========================================
  document.body.addEventListener('click', async (event) => {
    const button = event.target.closest('.rb-product-card__add-to-cart');
    if (!button || button.disabled || button.classList.contains('is-adding')) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    const originalText = button.innerHTML;
    button.classList.add('is-adding');
    button.disabled = true;
    button.innerHTML = '<span>Adding...</span>';

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || err.message || 'Error adding item');
      }

      // Fetch fresh cart info for real-time count
      const cartRes = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js');
      const cartData = await cartRes.json();
      cartData.totalQuantity = cartData.item_count;

      // Dispatch event to update cart-icon count badge WITHOUT opening drawer
      // action = 'catalog-add' prevents cart-drawer.js from opening the right sidebar
      const cartPromise = Promise.resolve({
        cart: cartData,
        detail: { action: 'catalog-add', itemCount: cartData.item_count }
      });
      const updateEvent = new CustomEvent('shopify:cart:lines-update', {
        bubbles: true,
        cancelable: true,
        detail: { action: 'catalog-add', itemCount: cartData.item_count }
      });
      updateEvent.action = 'catalog-add';
      updateEvent.promise = cartPromise;
      document.dispatchEvent(updateEvent);

      button.classList.remove('is-adding');
      button.classList.add('is-added');
      button.innerHTML = '<span>Added ✓</span>';

      setTimeout(() => {
        button.classList.remove('is-added');
        button.disabled = false;
        button.innerHTML = originalText;
      }, 1500);

    } catch (err) {
      console.error('Catalog Add-to-Cart Error:', err);
      button.classList.remove('is-adding');
      button.disabled = false;
      button.innerHTML = '<span>Failed</span>';

      setTimeout(() => {
        button.innerHTML = originalText;
      }, 1500);
    }
  });
});
